"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        {[1, 2, 3, 4, 5].map(i => <div key={i} data-index={i} className="h-9 w-16 bg-muted-light/20 animate-pulse rounded-md" />)}
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative px-4 py-2 text-base font-medium text-foreground hover:text-primary-dark transition-colors duration-200 after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-0 after:h-0.5 after:bg-primary-light after:transition-all after:duration-300 hover:after:w-full">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden" aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b shadow-medium md:hidden z-50">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-2">
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-4 py-3 text-base font-medium text-foreground hover:bg-accent hover:text-accent-foreground rounded-md transition-all" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
            <Button asChild className="w-full btn-primary mt-2">
              <Link to="#">Schedule a Consultation</Link>
            </Button>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`font-sans sticky top-0 z-50 w-full transition-all duration-300 ${scrolled ? "shadow-soft" : ""}`}>
      {}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1475438/img/header_background_tech_pattern.png" alt="" className="h-full w-full object-cover opacity-5" />
        <div className="absolute inset-0 bg-background/95 backdrop-blur-sm" />
      </div>

      {}
      <div className="relative z-10">
        {}
        <div className="container mx-auto px-4 flex items-center justify-between !h-[100px]">
          {}
          <Link to="/HomePage" className="flex-shrink-0">
            <img alt="Flex DPS" className="w-32 md:w-40 !h-auto" src="https://flexrnd.com/wp-content/uploads/2026/05/flex-logo.jpg" />
          </Link>

          {}
          <MenuProvider menu_id="17" className="flex-1 flex justify-center">
            <HeaderMenuConsumer />
          </MenuProvider>

          {}
          <Button asChild className="h-9 items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive bg-primary text-primary-foreground shadow-xs px-4 py-2 has-[>svg]:px-3 hidden btn-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] !h-[46px] !text-base disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 md:inline-flex hover:scale-105 hover:shadow-medium">
            <Link to="/ContactPage">Get Started</Link>
          </Button>
        </div>

        {}
      </div>
    </header>;
}